import { useState } from "react";
import { usePath } from "../../libs/path/PathProvider";
import Foods from "../../data/Foods";
import { UpdateEvent } from "../../gui/GUIEvents";
import Dropdown from "../../gui/Dropdown/Dropdown";
import GUI from "../../gui/GUI";

export interface IFoodSearchProps {
    className:string
    onSearch:(id:number) => void
}
export default function FoodSearch(props:IFoodSearchProps){
    const {path} = usePath()
    const [selected,setSelected] = useState<number>(parseInt(path.split("/")[2])||0)

    const onUpdate = (e:UpdateEvent<number>) => {
        if (!e.value) return
        else props.onSearch(e.value)
        setSelected(e.value)
    }

    return <div className={GUI.joinClass("search",props.className)}>
        <Dropdown options={Foods.i.options} onUpdate={onUpdate} value={selected} defaultValue={selected} placeholder="Search" anchorProps={{width:"match"}}/>
    </div>
}